import React from 'react';
import { Col, Form, Input, Row, Tag } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import FormListAddButton from '../../FormListAddButton';
import PriceMatrixEntryInput from './PriceMatrixEntryInput';
import { ServicePriceMatrix } from '../../../../../server/src/models';

interface PriceMatrixServiceTypeInputProps {
    isDetailMode: boolean;
    serviceMatrix: ServicePriceMatrix | undefined;
    fieldName: number;
    remove: (index: number | number[]) => void;
}

const PriceMatrixServiceInput: React.FC<PriceMatrixServiceTypeInputProps> = ({
    isDetailMode,
    serviceMatrix,
    fieldName,
    remove,
}: PriceMatrixServiceTypeInputProps) => (
    <>
        <Row gutter={24}>
            <Col span={10} xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 10 }}>
                <Form.Item
                    labelCol={{ span: 4 }}
                    name={[fieldName, 'type']}
                    label={isDetailMode ? '' : 'Service'}
                    style={{ fontWeight: 'bold' }}
                    rules={[
                        {
                            required: !isDetailMode,
                            message: 'Service type is required',
                        },
                    ]}
                >
                    {isDetailMode ? <span>{serviceMatrix?.type}</span> : <Input title="Service type" />}
                </Form.Item>
            </Col>
            {!isDetailMode && (
                <Col span={1}>
                    <span className="ant-form-text text-secondary" style={{ marginTop: '5px', cursor: 'pointer' }}>
                        <Tag
                            color="red"
                            style={{ cursor: 'pointer' }}
                            onClick={(): void => remove?.(fieldName)}
                            id={`service_delete_${fieldName}`}
                        >
                            <DeleteOutlined />
                        </Tag>
                    </span>
                </Col>
            )}
        </Row>
        {isDetailMode && (
            <Row id="price-service-header" gutter={24}>
                <Col span={5} offset={1}>
                    Max weight
                </Col>
                <Col span={5} offset={1}>
                    Max length
                </Col>
                <Col span={5} offset={1}>
                    Price
                </Col>
                <Col span={5} offset={1}>
                    Next day price
                </Col>
            </Row>
        )}
        <Form.List name={[fieldName, 'prices']}>
            {(fields, { add, remove: removePrice }): JSX.Element => (
                <>
                    {fields.map((field) => (
                        <PriceMatrixEntryInput
                            key={field.key}
                            isDetailMode={isDetailMode}
                            fieldName={field.name}
                            prices={serviceMatrix?.prices[field.key]}
                            remove={removePrice}
                        />
                    ))}
                    <Row gutter={24}>
                        <Col span={23} offset={1}>
                            <FormListAddButton
                                id={`add-price-matrix-entry_${fieldName}`}
                                add={add}
                                isDetailMode={isDetailMode}
                                text="Add a price"
                            />
                        </Col>
                    </Row>
                </>
            )}
        </Form.List>
    </>
);

export default PriceMatrixServiceInput;
